import { useEffect, useState } from "react"
import { useI18next } from "gatsby-plugin-react-i18next"
import axios from "axios"

export default function useFetcher(url, initialData = []) {
  const { language } = useI18next()
  const [state, setState] = useState({
    loading: true,
    data: initialData,
    error: "",
  })
  useEffect(() => {
    if (url) {
      setState({ loading: true, data: initialData, error: "" })
      axios
        .get(process.env.GATSBY_API_URL + "/frontend" + url, {
          // headers: {
          //   ["X-localization"]: language.toString(),
          // },
        })
        .then(async res => {
          setState({
            loading: false,
            data: res.data.data || res.data,
            error: "",
          })
        })
        .catch(err => {
          setState(p => ({ ...p, loading: false, error: err }))
        })
    }
  }, [url, language])
  return state
}
